import { CircleX } from "lucide-react";

export const AcrScheduleNewModal = ({ handleCancel }) => {
  return (
    <div className="Schedule_new_case_modal_wrapper">
      <div className="schedule-form-wrapper">
        <form className="schedule-form">
          <div className="schedule-form-header">
            <p>Schedule New Case</p>
            <button type="button" onClick={handleCancel}>
              <CircleX />
            </button>
          </div>
          <div className="schedule-input-btn-wrapper">
            <div className="schedule-input-wrapper">
              <div>
                <label htmlFor="date">Date</label>
                <input type="date" id="date" />
              </div>
              <div>
                <label htmlFor="time">Time</label>
                <input type="time" id="time" />
              </div>
            </div>

            <div
              style={{
                justifyContent: "flex-end",
              }}
              className="assign-case-button-group"
            >
              <button
                style={{
                  height: "42px",
                  maxWidth: "132px",
                }}
                onClick={handleCancel}
                type="button"
              >
                Cancel
              </button>
              <button
                style={{
                  height: "42px",
                  maxWidth: "224px",
                }}
                className=""
              >
                Schedule New Case
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
